app = app || {};
app.cw = app.cw || {};
app.cw.telerik = app.cw.telerik || {};

app.cw.telerik.tabStrip = {
    onSelect: function onSelect(e) {
        // load grid inside tab only when tab is clicked
        const gridId = $(e.contentElement).find('[data-role="grid"]').prop('id');
        const $grid = $('#' + gridId).data('kendoGrid');
        if ($grid)
            $grid.dataSource.read();
    }
};